// extracted by mini-css-extract-plugin
export default {"AlignmentButtons":"align-buttons_AlignmentButtons__0++1V"};